<template>
  <div id="app">
    <div class="is-login d-flex" v-if="logged && path != 'form-quote' && path != 'form-price'">
      <!--<transition name="bounce">
        <div
          class="app-menu-left"
          :class="[showText ? 'app-menu-left-full' : '']"
        >
          <menu-left @toggleMenu="toggleMenuParent"></menu-left>
        </div>
      </transition>-->
      <div
        class="app-content-right"
        :class="[
          showText ? 'app-content-right-full' : '',
          isPopupChat ? 'pb100' : ''
        ]"
      >
        <div class="header-top">
          <header-top></header-top>
        </div>
        <div class="content-bottom">
          <transition name="slide-fade">
            <router-view />
          </transition>
        </div>
      </div>
    </div>
    <div class="not-login" v-else>
      <router-view />
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from "vuex";
import ls from "local-storage";
// import MenuLeft from "@/views/layout/MenuLeft";
import HeaderTop from "@/views/layout/HeaderTop";
export default {
  name: "App",
  metaInfo () {
    return {
      title: this.title,
      titleTemplate: 'Hệ thống báo giá | %s'
    }
  },
  components: {
    // MenuLeft,
    HeaderTop,
  },
  computed: {
    ...mapGetters("account", ["logged"]),
    ...mapGetters(["path", "full_path"]),
    isPopupChat () {
      return this.path !== 'chat-list'
    },
  },
  data() {
    return {
      showText: false,
    };
  },
  mounted() {
    this.checkLoged();
  },
  methods: {
    ...mapActions("account", ["getAccountInfo"]),
    checkLoged() {
      let authen = ls.get("authen");
      if (!authen) {
        if (this.path == "form-quote") {
          this.$router.push({ name: "form-quote" });
          return;
        }
        if (this.path == "form-price") {
          this.$router.push({ name: "form-price" });
          return;
        }
        if (this.path !== "register") {
          this.$router.push({ name: "account-login" });
        }
      } else {
        if (!this.logged) {
          this.getAccountInfo();
        }
      }
    },

    toggleMenuParent(value) {
      this.showText = value;
    },
  },
};
</script>

<style>
.app-menu-left {
  min-height: 100vh;
  width: 50px;
  background-color: #1975b8;
  transition: 0.3s;
}
.app-content-right {
  /*width: calc(100% - 50px);*/
  /*height: 100%;*/
  /*height: 100vh;*/
   width: 100%;
  display: flex;
  flex-direction: column;
  transition: 0.3s;
  background: #effafe;
}
.app-content-right .header-top {
  background-color: #fff;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px #DFE8FD;

}
.app-content-right .content-bottom {
  height: 100%;
  margin: 10px 10px;
  border-radius: 13px;
  padding: 10px 10px;
}


/*Hiệu ứng*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
  .pb100 {
    padding-bottom: 100px;
  }
</style>
